import { Typography } from 'antd';

const FormLabel = ({ fs = 'f-12', children, className = '' }) => {
  return <Typography.Text className={` ${fs} text-label ${className}`}>{children}</Typography.Text>;
};

export default FormLabel;
